module.exports = __webpack_public_path__ + "static/viber_chat_uat-da13870a4aa8aac0455fb24b9561d13c.png";